<div
  *ngFor="let dot of iterableArr; trackBy: trackBy; let index = index"
  [class.active]="active === index"
  (click)="select.emit(dot)"
  class="dot"
></div>
